export default "__VITE_ASSET__8b7c303e__"